import request from '@/utils/request'

// 获取每日数据统计-题库
export function getDailyTestModelStats(params) {
  return request({
    url: '/getDailyTestModelStats',
    method: 'get',
    params
  })
}

// 获取题库数据数量
export function getBelongAndRecordCount(params) {
  return request({
    url: '/getBelongAndRecordCount',
    method: 'get',
    params
  })
}
